import React from "react";
import { PageHero, PageBody, STATIC_CONTENT, renderInstituteHtml } from "./_shared";
import { useNursing } from "./NursingLayout";
import { Sparkles, Target, Compass } from "lucide-react";

export default function About() {
  const data = useNursing();
  const trust = data.trust || {};
  return (
    <div data-testid="nur-about">
      <PageHero
        eyebrow="Our Story"
        title="A modern engineering campus, built on a 50-year academic legacy."
        subtitle="Marathwada Institute of Technology, CIDCO is part of Gramaudyogik Shikshan Mandal's flagship cluster — committed to building engineers who think rigorously and ship boldly."
      />
      <PageBody>
        {/* Trust strip */}
        <div className="bg-white rounded-2xl shadow-md border-l-4 border-[#0FB28A] p-7 mb-10 ring-1 ring-[#E2E8F0]">
          <div className="flex items-start gap-5 flex-wrap">
            {trust.logo_url && (
              <img src={trust.logo_url} alt="GSM" className="w-24 h-24 rounded-lg object-contain bg-[#F4F6FA] ring-1 ring-[#E2E8F0] p-2" />
            )}
            <div className="flex-1 min-w-[260px]">
              <h2 className="font-['Poppins',sans-serif] font-bold text-2xl text-[#0F2A5F]">
                {trust.trust_name || "Gramaudyogik Shikshan Mandal (GSM)"}
              </h2>
              {trust.registration_number && (
                <div className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#0FB28A] font-semibold">
                  Reg. No · {trust.registration_number}
                </div>
              )}
              <p className="mt-3 text-sm text-[#475569] leading-relaxed">
                Established in 1975, GS Mandal is a multi-institution trust whose mission is rural-industrial education in Marathwada.
                The Mandal&apos;s portfolio spans engineering, polytechnic, science &amp; technology, and food technology — with thousands of alumni
                serving across India and abroad.
              </p>
            </div>
          </div>
        </div>

        {/* About + Vision + Mission */}
        <div className="grid md:grid-cols-3 gap-5">
          <div className="md:col-span-2 bg-white rounded-2xl shadow-md p-7 border-t-4 border-[#0FB28A] ring-1 ring-[#E2E8F0]">
            <Sparkles className="text-[#0FB28A]" size={26} strokeWidth={1.5} />
            <h2 className="mt-2 font-['Poppins',sans-serif] font-bold text-2xl text-[#0F2A5F]">About the Campus</h2>
            <div className="mt-3 text-sm text-[#475569] leading-relaxed prose prose-sm max-w-none" data-testid="nur-about-institute" dangerouslySetInnerHTML={{ __html: renderInstituteHtml((data.institute?.about_institute || "").trim() || STATIC_CONTENT.about_intro) }} />
          </div>
          <div className="space-y-5">
            <div className="bg-gradient-to-br from-[#0F2A5F] to-[#1B3E83] text-white rounded-2xl p-6 shadow-md">
              <Target size={22} strokeWidth={1.5} className="text-[#7FE7CE]" />
              <h3 className="mt-2 font-['Poppins',sans-serif] font-bold text-lg">Our Vision</h3>
              <div className="mt-2 text-[12px] text-white/85 leading-relaxed prose prose-invert prose-sm max-w-none" data-testid="nur-about-vision" dangerouslySetInnerHTML={{ __html: renderInstituteHtml((data.institute?.vision || "").trim() || STATIC_CONTENT.vision) }} />
            </div>
            <div className="bg-gradient-to-br from-[#0FB28A] to-[#0E916F] text-white rounded-2xl p-6 shadow-md">
              <Compass size={22} strokeWidth={1.5} className="text-white" />
              <h3 className="mt-2 font-['Poppins',sans-serif] font-bold text-lg">Our Mission</h3>
              <div className="mt-2 text-[12px] text-white/95 leading-relaxed prose prose-invert prose-sm max-w-none" data-testid="nur-about-mission" dangerouslySetInnerHTML={{ __html: renderInstituteHtml((data.institute?.mission || "").trim() || STATIC_CONTENT.mission) }} />
            </div>
          </div>
        </div>
      </PageBody>
    </div>
  );
}
